"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubstrateNotCompatibleWithFramesRule = void 0;
var Glossary_1 = require("../../helpers/Glossary");
var SubstrateNotCompatibleRule_1 = require("./SubstrateNotCompatibleRule");
var SubstrateNotCompatibleWithFramesRule = /** @class */ (function (_super) {
    __extends(SubstrateNotCompatibleWithFramesRule, _super);
    function SubstrateNotCompatibleWithFramesRule() {
        var _this = _super.call(this) || this;
        _this.incompatibleSubstrates = [];
        _this.optionNoneSelected = Glossary_1.Glossary.NO_FRAME_TYPE;
        _this.messageSelector = '.paper-select .js-substrate-frame-incompatibility';
        _this.disabledClass = 'is-disabled-because-frame';
        _this.incompatibleSubstrates = ['[data-paper=P50]'];
        _this.firstFallbackSubstrate = '[data-paper=P08]';
        _this.secondFallbackSubstrate = '[data-paper=P01]';
        return _this;
    }
    return SubstrateNotCompatibleWithFramesRule;
}(SubstrateNotCompatibleRule_1.SubstrateNotCompatibleRule));
exports.SubstrateNotCompatibleWithFramesRule = SubstrateNotCompatibleWithFramesRule;
